import {
  AfterViewInit,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgProgressService } from '@shared/services/ng-progress.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { PopoverModule } from 'primeng/popover';
import { RewardsService } from './rewards.service';
import { InvestementTireType, Rewards } from './rewards.model';
import { combineLatest, filter, Subscription } from 'rxjs';
import { ProfileService } from '../profile/profile.service';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ProgressBarModule } from 'primeng/progressbar';
import { SkeletonModule } from 'primeng/skeleton';
import { Router } from '@angular/router';
import { CustomCurrencyPipe } from '@shared/pipes/custom-currency.pipe';

@Component({
  selector: 'app-rewards',
  imports: [
    CommonModule,
    CardModule,
    DividerModule,
    AngularSvgIconModule,
    PopoverModule,
    InputTextModule,
    FormsModule,
    ButtonModule,
    ProgressBarModule,
    SkeletonModule,
    CustomCurrencyPipe,
  ],
  templateUrl: './rewards.component.html',
})
export class RewardsComponent implements OnInit, AfterViewInit, OnDestroy {
  rewards: Rewards | null = null;
  currency: string | undefined;
  investAmountToReachNextTier: number | null = null;
  nextTier: string | null = null;
  InvestementTireType = InvestementTireType;

  private rewardsSub = Subscription.EMPTY;

  readonly _rewardsService = inject(RewardsService);
  private readonly _ngProgressService = inject(NgProgressService);
  private readonly _profileService = inject(ProfileService);
  private readonly _messageService = inject(MessageService);
  private readonly _router = inject(Router);

  ngOnInit(): void {
    this._ngProgressService.startLoader();

    this.currency = this._profileService.profile.currency;

    this.rewardsSub = this._rewardsService.rewards$.subscribe((rewards) => {
      this.rewards = rewards;
    });

    combineLatest([
      this._rewardsService.rewards$,
      this._rewardsService.investmentTires$,
    ])
      .pipe(
        filter(
          ([rewards, investmentTires]) =>
            rewards !== null &&
            rewards !== undefined &&
            investmentTires !== null &&
            investmentTires !== undefined
        )
      )
      .subscribe(([rewards, investmentTires]) => {
        console.log();

        const currentTierIndex = investmentTires?.findIndex(
          (tier) => tier.type === rewards?.currentInvestementTire
        );

        const nextTier = investmentTires![currentTierIndex! + 1];
        this.nextTier = nextTier?.title ?? null;
        this.investAmountToReachNextTier = nextTier?.investToUnlock ?? null;
      });

    this._rewardsService.getRewards();
    this._rewardsService.getInvestmentTires();
  }

  ngAfterViewInit(): void {
    this._ngProgressService.completeLoader();
  }

  copySharedLink(referLink?: string): void {
    referLink = referLink ?? '';
    navigator.clipboard.writeText(referLink).then(() => {
      this._messageService.clear();
      this._messageService.add({
        severity: 'success',
        summary: 'Link copied',
      });
    });
  }

  onTierNavigation(): void {
    this._router.navigate(['home/rewards/tier']);
  }

  ngOnDestroy(): void {
    this.rewardsSub.unsubscribe();
  }
}
